import { render, staticRenderFns } from "./intelligentCustomerService.vue?vue&type=template&id=5a408a8b&"
import script from "./intelligentCustomerService.vue?vue&type=script&lang=js&"
export * from "./intelligentCustomerService.vue?vue&type=script&lang=js&"
import style0 from "./intelligentCustomerService.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports